import React, {
  useState,
  useContext,
  useEffect,
  useRef
} from 'react';

import WithPopup from 'src/HOC/WithPopup/WithPopup';

import {
  isMobileView,
  registerEnterEvent,
  createArray,
  checkInputValidity,
  checkAlternativeInputValidity,
  getTrackingIds
} from 'src/Utility/utility';

import {
  BlackCellphoneIcon,
  GreenCircleIcon,
  RedCircleIcon
} from 'src/Components/Common/Svg/index';

import {
  FormFieldLabel
} from 'src/StyledComponents';

import VettingInput from 'src/Components/Common/VettingInput/VettingInput';

import VettingDropDown from 'src/Components/Common/VettingDropDown/VettingDropDown';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  submitCallmeBack
} from 'src/Services/Services';

import {
  tagOnCallMeBackPopupLoad,
  tagOnCallMeBackSuccessPopup,
  tagOnCallMeBackFail,
  tagOnCallMeBackFormInteraction
} from 'src/Tagging/SalesTagging';

import NewWhatsappBtn from '../WhatsappBtn/NewWhatsappBtn';

import './CallMeBackPopup.css';
import PrivacyCheckbox from '../PrivacyCheckbox/PrivacyCheckbox';

const CallMeBackPopup = () => {
  useEffect(() => {
    tagOnCallMeBackPopupLoad();
  }, []);

  const [ callMeBackStatus, setCallMeBackStatus ] = useState('pending');
  const context = useContext(SalesContext);
  const [ isFormValid, setIsFormValid ] = useState(false);
  const [ _isFormValidCheck, setisFormValidCheck ] = useState(false);
  const [ isVaidAltForm, setisVaidAltForm ] = useState(true);
  const [ isFocused, setIsFocused ] = useState(false);
  const [ isTermsAccepted, setIsTermsAccepted ] = useState(false);
  const [ showError, setShowError ] = useState(false);
  const miniAppProactiveSales = !!(window.isFtthMA);

  const [ AlternativeFormData, setAlternativeFormData ] = useState({
    AlternativeformComponents: {
      alternativeFirstName: {
        name: 'Contact person name (Optional)',
        type: 'input',
        value: '',
        width: 50,
        validations: {
          required: false,
          invalidMessage: 'Please enter a valid name',
          minLength: 2,
          maxLength: 50
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Eg. John',
          tabIndex: '6',
          minLength: 2,
          maxLength: 50

        },
        isValid: true,
        isTouched: false
      },
      alternativeCellPhoneNo: {
        name: 'Alternative cellphone number (Optional)',
        type: 'input',
        value: '',
        width: 50,
        validations: {
          type: 'cellphoneNo',
          required: false,
          invalidMessage: 'Please enter a valid cell phone number'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Eg. 082 1234 567',
          tabIndex: '7'
        },
        isValid: true,
        isTouched: false
      },
      alternativeEmail: {
        name: 'Alternative email address (Optional)',
        type: 'input',
        value: '',
        width: 50,
        validations: {
          type: 'email',
          required: true,
          invalidMessage: 'Please enter a valid email address'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Eg. example@gmail.com',
          tabIndex: '8'
        },
        isValid: true,
        isTouched: false
      }
    },
    isFormValid: false
  });

  const [ formData, setFormData ] = useState({
    // Form Fields
    formComponents: {
      firstName: {
        name: 'Name',
        type: 'input',
        value: '',
        width: 50,
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid name',
          minLength: 2,
          maxLength: 50
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Eg. John',
          tabIndex: '1',
          minLength: 2,
          maxLength: 50

        },
        isValid: false,
        isTouched: false
      },
      lastName: {
        name: 'Last name',
        type: 'input',
        value: '',
        width: 50,
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid last name',
          minLength: 2,
          maxLength: 50
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Eg. Smith',
          tabIndex: '2',
          minLength: 2,
          maxLength: 50
        },
        isValid: false,
        isTouched: false
      },
      email: {
        name: 'Email address',
        type: 'input',
        value: '',
        width: 50,
        validations: {
          type: 'email',
          required: true,
          invalidMessage: 'Please enter a valid email address'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Eg. john@gmail.com',
          tabIndex: '3'
        },
        isValid: false,
        isTouched: false
      },
      cellPhoneNo: {
        name: 'Cellphone number',
        type: 'input',
        value: '',
        width: 50,
        validations: {
          type: 'cellphoneNo',
          required: true,
          invalidMessage: 'Please enter a valid cell phone number'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Eg. 082 1234 567',
          tabIndex: '4'
        },
        isValid: false,
        isTouched: false
      },
      preferredTime: {
        name: 'At what time can we contact you? (Optional)',
        type: 'dropDown',
        value: '',
        options: [ 'Anytime',
          '08:00  - 10:00',
          '10:00  - 12:00',
          '12:00  - 14:00',
          '14:00  - 16:00',
          '16:00  - 18:00',
          '18:00  - 20:00' ],
        width: 50,
        validations: {
          required: false,
          invalidMessage: 'Please select a valid slot'
        },
        config: {
          type: 'select',
          required: false,
          placeholder: 'Please select a time slot',
          tabIndex: '5'
        },
        isValid: true,
        isTouched: false
      }
    },
    isFormValid: false
  });

  // Create arrays
  const formCompArray = createArray(formData.formComponents);

  const AlternativeFormCompArray = createArray(AlternativeFormData.AlternativeformComponents);

  registerEnterEvent();

  const formComponentChangeHandler = (event, inputIdentifier) => {
    if (inputIdentifier === 'firstName' && event.length === 1) {
      tagOnCallMeBackFormInteraction('fibre is available');
    }
    const formCompsCopy = { ...formData.formComponents };

    const changedComponent = { ...formCompsCopy[inputIdentifier] };

    if (inputIdentifier === 'email' || inputIdentifier === 'cellPhoneNo') {
      changedComponent.value = event.trim();
    } else {
      changedComponent.value = event;
    }

    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    changedComponent.isTouched = true;

    const newFormComps = {
      ...formCompsCopy,
      [inputIdentifier]: changedComponent
    };

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;
    const isFormCheckValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });

    setIsFormValid(isFormValid);
    setisFormValidCheck(isFormCheckValid);
  };

  const alternativeFormComponentChangeHandler = (event, inputIdentifier) => {
    const alternativeFormCompsCopy = { ...AlternativeFormData.AlternativeformComponents };
    const changedComponent = { ...alternativeFormCompsCopy[inputIdentifier] };

    if (inputIdentifier === 'alternativeEmail' || inputIdentifier === 'alternativeCellPhoneNo') {
      changedComponent.value = event.trim();
    } else {
      changedComponent.value = event;
    }

    changedComponent.isValid = checkAlternativeInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    changedComponent.isTouched = changedComponent.value !== '';

    const newFormComps = {
      ...alternativeFormCompsCopy,
      [inputIdentifier]: changedComponent
    };
    const isFormValid = !Object.keys(newFormComps).some(e => newFormComps[e].isValid === false) ? true : false;

    setAlternativeFormData({
      AlternativeformComponents: newFormComps
    });

    setisVaidAltForm(isFormValid);
  };

  const onTermsChange = () => {

    let value = !isTermsAccepted;

    setIsTermsAccepted(value);

    if (showError && value === true) {

      setShowError(false);
    }
  }

  const contentStyleDesktop = {
    position: 'absolute',
    margin: 'auto',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%'
  };

  const contentStyleMobile = {
    position: 'absolute',
    margin: 'auto',
    top: '0%',
    width: '100%'
  };

  const closeCallMeBackPopup = () => {
    context.setShowCallMeBack(false);
  };

  const submitForm = () => {

    if (!isTermsAccepted) {
    
      setShowError(true);

      return;
    }

    const agentUsername = sessionStorage.getItem('retailUserDetails') ? JSON.parse(sessionStorage.getItem('retailUserDetails')).username : null;

    context.setShowSpinner(true);
    let payload = {
      leadType: 'callMeBack',
      contactEmailAddress: formData.formComponents.email.value,
      contactFirstName: formData.formComponents.firstName.value,
      contactLastName: formData.formComponents.lastName.value,
      contactMobilePhoneNumber: formData.formComponents.cellPhoneNo.value,
      preferredContactTime: formData.formComponents.preferredTime.value,
      mrktIndicator: getTrackingIds(),
      alternativeContactDetails: {
        alternativeContactFirstName: AlternativeFormData.AlternativeformComponents.alternativeFirstName.value,
        alternativeContactEmailAddress: AlternativeFormData.AlternativeformComponents.alternativeEmail.value,
        alternativeContactMobilePhoneNumber: AlternativeFormData.AlternativeformComponents.alternativeCellPhoneNo.value
      },
      channel: context?.selectedPackage?.status || 'Live',
      callMeBack: true
    };

    if (agentUsername) {

      payload.agent = {
        username: agentUsername
      };
    }

    submitCallmeBack(payload, context)
      .then(res => {
        context.setShowSpinner(false);
        context.setUserDetails({
          key: 'referenceNo',
          value: res.result && res.result.referenceNumber
        });
        setCallMeBackStatus('success');
        tagOnCallMeBackSuccessPopup(formData.formComponents.cellPhoneNo.value, res?.result?.referenceNumber);
      })
      .catch(_err => {
        context.setShowSpinner(false);
        setCallMeBackStatus('fail');
        tagOnCallMeBackFail('fibre is available');
      });
  };

  const popUpContainerRef = useRef(null);
  useOutsideAlerter(popUpContainerRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {

      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          context.setShowCallMeBack(false);
        }
      }

      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ ref ]);
  }

  useEffect(() => {

    const container = document.getElementsByClassName('callmeback-wrapper')[0];
    if (!container) {
      return;
    }

    const focusableElements = Array.from(container.querySelectorAll('input'));
    if (focusableElements.length === 0) {
      return;
    }

    focusableElements[0].focus();

    const handleKeyDown = (e) => {
      if (e.key !== 'Tab') {
        return;
      }

      const currentIndex = focusableElements.indexOf(document.activeElement);
      if (currentIndex === -1) {
        return;
      }

      e.preventDefault();

      let nextIndex;
      if (e.shiftKey) {

        nextIndex = (currentIndex - 1 + focusableElements.length) % focusableElements.length;
      } else {

        nextIndex = (currentIndex + 1) % focusableElements.length;
      }

      focusableElements[nextIndex].focus();
    };

    container.addEventListener('keydown', handleKeyDown);

    return () => {
      container.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (

    <div className="callmeback-wrapper">
      <WithPopup contentStyle={isMobileView() ? contentStyleMobile : contentStyleDesktop}>
        <div  ref={popUpContainerRef}  className={isFocused && miniAppProactiveSales && isMobileView() ? 'callmeback-container-miniapp-focused' : 'callmeback-container'}>
          <div
            className="callmeback-close-btn"
            onClick={() => closeCallMeBackPopup()}
          >
            x
          </div>

          {
            callMeBackStatus === 'pending' ?
              <div className="callmeback-head-section">
                <BlackCellphoneIcon />
                <div className="callmeback-heading">We’ll call you back</div>
                <div className="callmeback-desc">WhatsApp us or give us your information and a call centre agent will be in touch.
                </div>
                <NewWhatsappBtn/>
                <div className="callmeback-form-parentWrapper">
                  <div className="callmeback-form-wrapper">
                    {
                      formCompArray.map(item => {
                        return (
                          <div className={`input-field-wrapper-${ item.config.width }`} key={item.key}>
                            <FormFieldLabel
                              hide={item?.config?.hideLabel}
                              automationidattr={`contactDetails${ item.config.name }`}
                            >
                              {item.config.name}
                            </FormFieldLabel>
                            {
                              item.config.type === 'input' ?
                                <VettingInput
                                  {...item.config}
                                  updateValue={(value) => formComponentChangeHandler(value, item.key)}
                                  inputIdentifier={item.key}
                                  automationidattr={'contactDetails'}
                                  onFocus={(_event) => {
                                    setIsFocused(true);
                                  }}
                                  onBlur={(_event) => {
                                    setIsFocused(false);
                                  }}
                                />
                                :
                                null
                            }
                            {
                              item.config.type === 'dropDown' ?
                                <VettingDropDown
                                  selectedValue={item.config.value}
                                  placeholder={item.config.config.placeholder}
                                  options={item.config.options}
                                  updateSelectedOption={formComponentChangeHandler}
                                  inputIdentifier={item.key}
                                  automationidattr={item.key}
                                />
                                :
                                null
                            }
                          </div>
                        );
                      })
                    }
                  </div>

                  <div className='callmeback-privacy-wrapper'>
                    <PrivacyCheckbox 
                        checked={isTermsAccepted}
                        onChange={onTermsChange}
                        showError={showError}
                    />
                  </div>

                  <div className="callmeback-alt-heading">Alternative contact information</div>

                  <div className="callmeback-form-wrapper">
                    {
                      AlternativeFormCompArray.map(item => {
                        return (
                          <div className={`input-field-wrapper-${ item.config.width }`} key={item.key}>
                            <FormFieldLabel
                              hide={item?.config?.hideLabel}
                            >
                              {item.config.name}
                            </FormFieldLabel>
                            {
                              item.config.type === 'input' ?
                                <VettingInput
                                  {...item.config}
                                  updateValue={alternativeFormComponentChangeHandler}
                                  inputIdentifier={item.key}
                                  onFocus={(_event) => {
                                    setIsFocused(true);
                                  }}
                                  onBlur={(_event) => {
                                    setIsFocused(false);
                                  }}
                                />
                                :
                                null
                            }
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
                <div className="callmeback-submit-btn">
                  <button
                    className="callmeback-cancel-btn"
                    onClick={() => closeCallMeBackPopup()}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={!(isFormValid && isVaidAltForm)}
                    onClick={() => submitForm()}
                  >
                    Submit
                  </button>
                </div>
              </div>
              :
              null
          }

          {
            callMeBackStatus === 'success' ?
              <div className="callmeback-head-section">
                <GreenCircleIcon />
                <div className="callmeback-heading">Let&apos;s get connected!</div>
                <div className="callmeback-desc">Thanks for your interest in getting connected with our fibre plans. We can&apos;t wait to get you set up with lightning-fast internet.</div>
                <div className="callmeback-desc">A friendly sales agent will be in touch shortly to discuss your chosen plan and finalise your order.</div>

                { context?.userDetails?.referenceNo &&

                  <>
                    <hr className="callmeback-hrline" />
                    <div className="callmeback-ref-wrapper">
                      <div className="callmeback-desc"><strong>Reference number: </strong>{context?.userDetails?.referenceNo}</div>
                    </div>
                  </>
                }
                <div className="callmeback-oky-btn">
                  <button onClick={() => closeCallMeBackPopup()}>Okay</button>
                </div>
              </div>
              :
              null
          }

          {
            callMeBackStatus === 'fail' ?
              <div className="callmeback-head-section">
                <RedCircleIcon />
                <div className="callmeback-heading">Oops...</div>
                <div className="callmeback-desc">We were unable to submit your request. Please try again later.</div>
                <div className="callmeback-oky-btn">
                  <button onClick={() => closeCallMeBackPopup()}>Okay</button>
                </div>
              </div>
              :
              null
          }
        </div>
      </WithPopup>
    </div>
  );
};

export default CallMeBackPopup;